import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  output,
  ViewChild,
} from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-capture',
  standalone: true,
  imports: [],
  templateUrl: './signature-capture.component.html',
  styleUrl: './signature-capture.component.scss',
})
export class SignatureCaptureComponent implements OnInit, OnDestroy {

  confirmed = output<Blob>();

  @ViewChild('signatureCanvas', { static: true })
  canvasRef!: ElementRef<HTMLCanvasElement>;

  private signaturePad!: SignaturePad;
  private resizeObserver!: ResizeObserver;

  ngOnInit(): void {
    const canvas = this.canvasRef.nativeElement;
    this.scaleCanvas();
    this.signaturePad = new SignaturePad(canvas);

    this.resizeObserver = new ResizeObserver(() => {
      this.onResize();
    });
    this.resizeObserver.observe(canvas.parentElement ?? canvas);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  /*
   ██████╗ ██████╗ ███████╗██████╗  █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
  ██╔═══██╗██╔══██╗██╔════╝██╔══██╗██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
  ██║   ██║██████╔╝█████╗  ██████╔╝███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
  ██║   ██║██╔═══╝ ██╔══╝  ██╔══██╗██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
  ╚██████╔╝██║     ███████╗██║  ██║██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
   ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝

  */
  // region scaleCanvas
  scaleCanvas(): void {
    const canvas = this.canvasRef.nativeElement;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);

    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;

    canvas.getContext('2d')!.scale(ratio, ratio);
  }

  // region onResize
  onResize(): void {
    const data = this.signaturePad.toData();

    this.scaleCanvas();
    this.signaturePad.clear();
    this.signaturePad.fromData(data);
  }

  // region confirm
  confirm(): void {
    if(this.signaturePad.isEmpty()) return;

    const dataUrl = this.signaturePad.toDataURL('image/png');
    const base64 = dataUrl.split(',')[1];
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);

    for(let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    this.confirmed.emit(new Blob([bytes], { type: 'image/png' }));
  }

  // region clear
  clear(): void {
    this.signaturePad.clear();
  }

}
